import { handleClientError } from "lib/errors";

export const blogService = {
  /**
   * Fetches blog posts for a specific category
   * @param category - The blog category slug
   * @param page - Page number for pagination
   * @returns Promise<BlogPost[]>
   */
  async fetchPostsByCategory(category: string, page = 1) {
    const response = await fetch(`/api/blog-posts?category=${category}&page=${page}`);
    if (!response.ok) handleClientError(`Failed to fetch posts: ${response.statusText}`);
    return response.json();
  },

  /**
   * Fetches the blog count for a specific category
   * @param category - The blog category slug
   * @returns Promise<number>
   */
  async fetchBlogCount(category: string) {
    const response = await fetch(`/api/blog-count?category=${category}`);
    if (!response.ok) handleClientError(`Failed to fetch count: ${response.statusText}`);
    return response.json();
  },
};
